import {
    type AdminAgentNoteVolatility,
    type AdminScratchpadNoteSummaryRead,
} from '@libraries/typescript/api_client';

export const SCOPE_TYPES = [
    'global',
    'organization',
    'tool',
    'skill',
] as const satisfies ReadonlyArray<
    AdminScratchpadNoteSummaryRead['scope_type']
>;
export type ScopeType = (typeof SCOPE_TYPES)[number];

export const VOLATILITY_VALUES = [
    'stable',
    'volatile',
] as const satisfies ReadonlyArray<AdminAgentNoteVolatility>;
export type VolatilityFilter = (typeof VOLATILITY_VALUES)[number];

export const FRESHNESS_BUCKETS = ['24h', '7d', '30d'] as const;
export type FreshnessBucket = (typeof FRESHNESS_BUCKETS)[number];

export const SORT_FIELDS = [
    'updated_at',
    'last_verified_at',
    'created_at',
    'title',
] as const;
export type SortField = (typeof SORT_FIELDS)[number];

export const DEFAULT_PER_PAGE = 40;
export const SEARCH_DEBOUNCE_MS = 300;

export const SCOPE_LABELS: Record<ScopeType, string> = {
    global: 'Global',
    organization: 'Organization',
    tool: 'Tool',
    skill: 'Skill',
};

// Default scope kind for the bare /admin/agent/scratchpad view. `global` is
// the only kind whose valid request needs no scope_id — safe default that
// never triggers the API's cross-org guard. Explicit constant so the hook,
// Clear Filters, and the picker's placeholder all agree on the value.
export const DEFAULT_SCOPE_KIND: ScopeType = 'global';

export const VOLATILITY_LABELS: Record<VolatilityFilter, string> = {
    stable: 'Stable',
    volatile: 'Volatile',
};

export const FRESHNESS_LABELS: Record<FreshnessBucket, string> = {
    '24h': 'Last 24h',
    '7d': 'Last 7 days',
    '30d': 'Last 30 days',
};

export const SORT_LABELS: Record<SortField, string> = {
    updated_at: 'Updated',
    last_verified_at: 'Verified',
    created_at: 'Created',
    title: 'Title',
};
